import PropTypes from 'prop-types';
import React from 'react';
import { truncateWithEllipsis } from '../../../../utilities/ui_utilities';
import SetAlertButton from '../../../Input/ButtonWithChildren/SetAlertButton/SetAlertButton';
import './StickyAlertLayout.scss';

export default class StickyAlertLayout extends React.PureComponent {
    static propTypes = {
        /*Job Information*/
        jobSearches: PropTypes.shape({
            jobSearchTerm: PropTypes.string,
            jobLocation: PropTypes.string,
            jobLat: PropTypes.number,
            jobLng: PropTypes.number,
        }),
        /**
         * active state
         * */
        active: PropTypes.bool,
        /**
         * onclick function
         * */
        onClick: PropTypes.func,
        /**
         * show button
         * */
        showButton: PropTypes.bool,
    };

    render() {
        const jobTitle = this.props.jobSearches.jobSearchTerm || null;
        const jobLocation = this.props.jobSearches.jobLocation || null;
        const jobText = `${jobTitle} in ${jobLocation}`;

        return (
            <div className="component-Layout-StickyTopBar-StickyAlertLayout">
                <div className="left">{truncateWithEllipsis(jobText, 63)}</div>
                <SetAlertButton
                    onClick={this.props.onClick}
                    active={this.props.active}
                />
            </div>
        );
    }
}
